<section  class="review-section">
  <div class="box">
    <ng-container *ngIf="reviewContent && reviewContent?.reviewActive">
      <h2 id="reviewSection" class="sub-heading" [innerHTML]="reviewContent?.heading"></h2>
      <p class="prl-wrapper" [innerHTML]="reviewContent?.description"></p>
      <div class="content pr-review-snippet-container">
        <!-- Power Review -->
        <section #prReviewSection class="pdpddl-cards-details-section ddlpr">
          <div class="pdpddl-cards-details-content">
            <ui-reviews-container [pid]="cardDetails?.pid"></ui-reviews-container>
          </div>
        </section>
      </div>
    </ng-container>
    <div class="apply-now-section">
      <p class="pr-disclaimer m-0" *ngIf="reviewContent && reviewContent?.reviewActive" [innerHTML]="reviewContent?.disclaimer"></p>
      <div class="wrapper">
        <div class="cardart-section" *ngIf="cardDetails?.displayCardArtApplyNowSection">
          <div class="cardart" *ngFor="let card of reviewContent?.cardImagesApplyNow">
            <h4 [innerHTML]="card?.cardTitle" *ngIf="cardDetails?.displayCardNameApplyNowSection"></h4>
            <app-card-art
                        [pid]="card.pid"
                        defaultSize="md"
                        [linkHref]="card.crsApplyNowURL? card.crsApplyNowURL : cardApplyNowBtnLink"
                        [linkTarget]="'_blank'"
                        [enablePdpLink]="false"
                        (click)="applyNow('cardArtBodyCRS'+card.pid)"
                    ></app-card-art>
            <ui-card-button *ngIf="cardDetails?.cardApplyNowBtnText" [btnName]="cardDetails?.cardApplyNowBtnText" [btnLink]="card?.crsApplyNowURL" (click)="applyNow('applyNowBodyCRS'+card.pid)"        
            [cardName]="cardDetails?.cardName" [size]="0"  [hrefTarget]="hrefTarget">
            </ui-card-button>
          </div>
        </div>
        <ui-card-button *ngIf="cardDetails?.cardApplyNowBtnText && !reviewContent?.cardImagesApplyNow" [btnName]="cardDetails?.cardApplyNowBtnText" [btnLink]="cardApplyNowBtnLink" (click)="applyNow('applyNowBodyOthers')"          
          [cardName]="cardDetails?.cardName" [size]="0"  [tagText]="cardDetails?.cardApplyNowBtnText.toLowerCase()+' bottom'" [hrefTarget]="hrefTarget">
        </ui-card-button>
        <div class="customer-support" *ngIf="cardDetails?.customerSupportText" [innerHTML]="cardDetails?.customerSupportText"></div>
      </div>
    </div>
    <div class="spacer" role="presentation" aria-hidden="true"></div>
  </div>
</section>
